import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ContentBox from "../../../actprep-ui/components/ContentBox";
import layout from "../../../actprep-ui/constants/layout";
import OrgToProgramAutomationEditor from "../../../components/OrgToProgramAutomationEditor";
import TicketTailorMappingEditor from "../../../components/TicketTailorMappingEditor";

export default function Automations() {
  return (
    <>
      <Grid
        sx={{
          marginTop: `${layout.navBarHeight + 1}rem`,
          marginBottom: "5rem",
        }}
        size={12}
        container
        direction="column"
        flexWrap={"nowrap"}
      >
        <Grid size={1} sx={{ maxHeight: "3rem" }}>
          <Typography variant="h5" fontWeight="bold" color="primary">
            Automations
          </Typography>
        </Grid>
        <Grid size={11} spacing={3} container>
          <Grid
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <ContentBox>
              <OrgToProgramAutomationEditor />
            </ContentBox>
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
            }}
          >
            <ContentBox>
              <TicketTailorMappingEditor modelName={"StudentProfile"} />
            </ContentBox>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
